<template>
  <div class="sign-main">
    <div class="sign_box">
      <div class="box_left" v-bind:class="{ active: open }">
        <img class="logo" src="@/assets/logo/logo.png" />
        <div class="title">Production Portal</div>
        <div class="box_left_b">
          <div class="btn_tip">
            <span style="color: red">*</span>Please connect wallet:
          </div>
          <mmLogin ref="mmLogin" @success="getRoles"></mmLogin>
          <div class="foot_tip">
            After logging in with an unregistered account, it will be automatically
            registered.
          </div>
        </div>
      </div>
      <div class="box_right fr" v-if="open">
        <img class="logo" src="@/assets/logo/logo.png" />
        <div class="title">Production Portal</div>
        <div class="box_list">
          <div class="tip">Please select a role:</div>
          <div
            class="listItem"
            v-for="item in roleList"
            :key="item.type"
            @click="getSignture(item)"
          >
            <span v-if="item.type == 0">Producer</span>
            <span v-if="item.type == 1">FoundationManager</span>
            <span v-if="item.type == 3">Beneficiary</span>
            <account v-if="item.producerAddress" :value="item.producerAddress" style="color: #999;" />
          </div>
          <div class="btn">
            <el-button type="text" @click="handleBack">
              <img class="icon_back" src="@/assets/image/login/back.png" />
              Reselect wallet
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mmLogin from "./mmLogin.vue";
import { getNonce, getAccountList, handleLogin } from "@/api/login.js";
export default {
  components: {
    mmLogin,
  },
  data() {
    return {
      open: false,
      form: {
        address: undefined,
        signature: undefined,
        userID: undefined,
      },
      roleList: [],
    };
  },
  computed: {},
  methods: {
    getRoles(account) {
      
      this.form.address = account;
      this.getAccountList().then((res) => {
        if (this.roleList.length === 1) {
          this.getSignture(this.roleList[0]);
        } else {
          this.open = true;
        }
      });
    },
    getAccountList() {
      return new Promise((resolve, reject) => {
        getAccountList(this.form.address)
          .then((res) => {
            this.roleList = res.result.data;
            resolve();
          })
          .catch((err) => {
            reject();
          });
      });
    },
    getNonce(userid) {
      return new Promise((resolve, reject) => {
        let json = {
          address: this.form.address,
          userID: userid,
        };
        getNonce(json)
          .then((res) => {
            resolve(res.result.hexMsg);
          })
          .catch((err) => {
            reject();
          });
      });
    },
    async getSignture(item) {
      try {
        await window.ethereum.enable();
        console.log("getSignture", item);
        let data = await this.getNonce(item.userID);
        this.form.signature = await window.ethereum.request({
          method: "personal_sign",
          params: [data, this.form.address],
        }); // usedAPI /common/login
        this.handleLogin(item);
      } catch (error) {
        this.$refs.mmLogin.loginResult("error");
        console.log(error);
      }
    },
    handleLogin(item) {
      if (item) {
        this.form.userID = item.userID;
      }
      this.$store
        .dispatch("Login", this.form)
        .then(() => {
          this.$refs.mmLogin.loginResult("success");
          this.loading = false;
          if (item.type == 3) {
            this.$router.push("/wellManagement/myWells");
          } else {
            this.$router.push("/");
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    handleBack(){
      this.open = false
      this.$refs.mmLogin.loginResult("error");
    }
  },
  created() {},
  mounted() {},
  watch: {},
};
</script>
<style lang="scss">
.sign-main {
  width: 100%;
  height: 100%;
  background: url("~@/assets/image/login/big-bg2.png") no-repeat center center;
  background-size: cover;

  .sign_box {
    width: 10.52rem;
    // min-height: 4.44rem;
    margin: 0 auto;
    padding-top: 2.56rem;

    .logo {
      width: 1.43rem;
      padding-left: 0.32rem;
      padding-top: 0.28rem;
    }

    .title {
      height: 0.38rem;
      font-size: 0.32rem;
      font-family: Roboto-Bold, Roboto;
      font-weight: bold;
      color: #333333;
      line-height: 0.38rem;
      margin-top: 0.44rem;
      margin-bottom: 0.48rem;
      text-align: center;
    }

    .box_left.active {
      float: left;
    }

    .box_left,
    .box_right {
      width: 4.86rem;
      background: #ffffff;
      box-shadow: 0px 20px 40px 0px rgba(31, 28, 44, 0.1);
      box-sizing: border-box;
      margin: 0 auto;

      .box_left_b,
      .box_list {
        background: #f7f8fa;
        padding: 0.24rem 0.32rem;
      }
    }
  }
}

.box_left_b {
  .btn_tip {
    height: 0.28rem;
    font-size: 0.18rem;
    font-family: Roboto-Regular, Roboto;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 0.28rem;
    margin-bottom: 0.1rem;
  }

  .foot_tip {
    font-size: 0.16rem;
    font-family: DMSans-Regular, DMSans;
    font-weight: 400;
    color: #8c8c8c;
    line-height: 0.24rem;
    margin-top: 0.64rem;
    padding: 0 0.16rem;
  }
}

.box_list {
  .tip {
    font-size: 0.18rem;
    font-family: Roboto-Regular, Roboto;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 0.28rem;
  }

  .listItem {
    height: 0.56rem;
    background: #ffffff;
    border-radius: 0.12rem;
    border: 2px solid #d9dde3;
    cursor: pointer;
    font-size: 0.18rem;
    font-family: Roboto-Medium, Roboto;
    font-weight: 500;
    color: #333333;
    line-height: 0.56rem;
    margin-top: 0.12rem;
    padding:0 0.16rem;
    display: flex;
    justify-content: space-between;
  }

  .btn {
    margin-top: 0.46rem;
    text-align: center;

    .icon_back {
      width: 0.16rem;
    }
  }
}
</style>
